import React from 'react';

export default () => (<div />);



// WEBPACK FOOTER //
// ./src/views/FinalPreview.js